import {createApp} from 'vue';
import IncidentStatus from './vue/IncidentStatus.vue';
import ActionPerspectives from "./vue/ActionPerspectives.vue";

window.addEventListener( 'DOMContentLoaded', () => {
  const incidentsElement = document.getElementById( 'vrgz-incident-comments' );
  if (!!incidentsElement) {
    const props = {};

    // Props for the vue component.
    if (!!incidentsElement.dataset.existingComments) {
      props.existingComments = JSON.parse( incidentsElement.dataset.existingComments );
    }

    if (!!incidentsElement.dataset.incidentId) {
      props.incidentId = parseInt( incidentsElement.dataset.incidentId );
    }

    if (!!incidentsElement.dataset.emptyMessage) {
      props.emptyMessage = incidentsElement.dataset.emptyMessage;
    }

    if (!!incidentsElement.dataset.loadingMessage) {
      props.loadingMessage = incidentsElement.dataset.loadingMessage;
    }

    if (!!incidentsElement.dataset.updateInterval) {
      props.updateInterval = parseInt( incidentsElement.dataset.updateInterval );
    }

    createApp( IncidentStatus, props ).mount( incidentsElement );
  }

  const actionPerspectivesElement = document.getElementById( 'action-perspectives' );
  if( !! actionPerspectivesElement ) {
    const props = {};
    if (!!actionPerspectivesElement.dataset.incidentId) {
      props.incidentId = parseInt( actionPerspectivesElement.dataset.incidentId );
    }

    if (!!actionPerspectivesElement.dataset.interval) {
      props.interval = parseInt( actionPerspectivesElement.dataset.interval );
    }
    if (!!actionPerspectivesElement.dataset.originals) {
      props.originals = JSON.parse( actionPerspectivesElement.dataset.originals );
    }

    if (!!actionPerspectivesElement.dataset.labels) {
      props.labels = JSON.parse( actionPerspectivesElement.dataset.labels );
    }

    createApp( ActionPerspectives, props ).mount( actionPerspectivesElement );
  }
} );
